import { useEffect } from 'react';
import { analytics, events } from 'services/analytics';
import distributionApi from 'services/api/distribution';

type CreateReleaseType = {
  hasUserAudio: boolean;
};

const useCreateRelease = ({ hasUserAudio }: CreateReleaseType) => {
  const [createNewRelease, { data, isSuccess, isLoading, isError, error }] =
    distributionApi.useCreateReleaseMutation();

  useEffect(() => {
    if (!isSuccess) {
      return;
    }
    analytics.track(events.releaseCreated({ hasUserAudio }));
  }, [isSuccess, hasUserAudio]);

  useEffect(() => {
    if (!isError) {
      return;
    }
    analytics.track(events.createReleaseError());
  }, [isError]);

  return {
    createNewRelease,
    data: data?.release,
    isSuccess,
    isLoading,
    isError,
    error,
  };
};

export default useCreateRelease;
